import { useState } from "react";
import { toast } from "sonner";
import axios from "axios";
import { Send } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Newsletter = ({ variant = "block", text }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Introduce un email válido");
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/newsletter`, { email, source: variant });
      toast.success(data.message || "¡Suscripción confirmada!");
      setEmail("");
    } catch {
      toast.error("No se pudo completar la suscripción. Inténtalo de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  const dark = variant === "footer";

  return (
    <div
      data-testid="newsletter"
      className={
        variant === "block"
          ? "bg-brand-forest text-white rounded-lg p-8 sm:p-12 my-12"
          : ""
      }
    >
      {variant === "block" && (
        <>
          <p className="text-xs uppercase tracking-[0.2em] text-brand-terra mb-3">Newsletter</p>
          <h3 className="font-heading text-3xl sm:text-4xl font-semibold mb-2">
            Chollos de viaje en tu correo
          </h3>
          <p className="text-white/70 mb-6 max-w-xl">
            {text || "Únete a miles de viajeros y recibe destinos baratos, errores de tarifa y trucos para ahorrar. Sin spam."}
          </p>
        </>
      )}
      <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-xl">
        <input
          data-testid="newsletter-email-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="tu@email.com"
          className={`flex-1 px-4 py-3 rounded-sm outline-none text-base ${
            dark ? "bg-white/10 text-white placeholder-white/50 border border-white/20" : "bg-white text-brand-ink border border-white/30"
          } focus:ring-2 focus:ring-brand-terra`}
        />
        <button
          data-testid="newsletter-submit-button"
          type="submit"
          disabled={loading}
          className="bg-brand-terra hover:bg-brand-terraDark text-white font-semibold px-6 py-3 rounded-sm transition-all hover:-translate-y-0.5 flex items-center justify-center gap-2 disabled:opacity-60"
        >
          {loading ? "Enviando…" : "Suscribirme"} <Send size={16} />
        </button>
      </form>
    </div>
  );
};
